import React, { Component } from 'react';
import { HashRouter, Switch } from 'react-router-dom';
import './scss/style.scss';
import './views/_custom.css';
import './components/styles.css';
import 'react-medium-image-zoom/dist/styles.css';
import {PublicRoute} from "./Routes/PublicRoute";
import {PrivateRoute} from "./Routes/PrivateRoutes";
import Alert from "./components/Alert";
import {AlertQuestion} from "./components/AlertQuestion";
import {ModalCRUD} from "./components/ModalCRUD";
import {LoaderMaestros} from "./components/Loader";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const TheLayout = React.lazy(() => import('./containers/TheLayout'));

const Login = React.lazy(() => import('./views/pages/login/Login'));


class App extends Component {

  render() {
    return (
      <div>
        <HashRouter>
            <Alert />
            <AlertQuestion />
            <ModalCRUD />
            <LoaderMaestros />
            <React.Suspense fallback={loading}>
              <Switch>
                <PublicRoute exact path="/login" component={Login} />
                <PrivateRoute path="/" component={TheLayout} />
              </Switch>
            </React.Suspense>
        </HashRouter>
      </div>
    );
  }
}

export default App;
